module.exports = __webpack_public_path__ + "static/img/41-3.7a717cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/41-3.jpg
// module id = YAId
// module chunks = 0